import React from "react";
import "./ProductCard.css";
import { Link } from "react-router-dom";
const ProductCard = ({ link, title, subtitle, image, showHover, hashTag }) => {
    return (
        <div className="col">
            <Link to={{ pathname: link, state: { hash: hashTag } }}>
            <div className="ImgCard">
                {/* <Link to={{ pathname: link, state: { hash: hashTag } }} > */}

                    {showHover && (
                        <div className="overlay">
                            <div className="overlay-text">View Product</div>
                        </div>
                    )}
                    <div className="card-content">
                        {image && (
                            <img src={image} className="POSDeviceImg" alt="Products" />
                        )}
                        <h4>{title}</h4>
                        <p>{subtitle}</p>
                    </div>
                {/* </Link> */}
            </div>
            </Link>
        </div >
    );
};
export default ProductCard;
